import { ObjectCreator } from './ObjectCreator'
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    ModalButton,
} from 'baseui/modal';
import {
    ProgressSteps,
    NumberedStep
} from "baseui/progress-steps";
import { Button, KIND, SIZE, SHAPE, ButtonProps } from 'baseui/button';
import { useState } from 'react'
import { IAutomationObject } from '../../automationObjects';
import { useStyletron } from 'baseui';


export interface AddObjectProps {
    object?: IAutomationObject,
    onClose: any,
}

export const AddObject = ({ object, onClose }: AddObjectProps) => {
    const [isOpen, setIsOpen] = useState(false);
    const [css] = useStyletron();

    function onFinish() {
        setIsOpen(false);
        onClose();
    }
    function onCancel() {
        setIsOpen(false);
        onClose();
    }

    return (
        <>
            <Button onClick={() => setIsOpen(true)} shape='circle' kind='primary'   >
                +
            </Button>
            <Modal animate
                autoFocus
                role={'dialog'}
                closeable onClose={onCancel} isOpen={isOpen}
                overrides={{
                    Dialog: {
                      style: {
                        width: '90vw',
                        height: '90vh',
                        display: 'flex',
                        flexDirection: 'column',
                      },
                    },
                  }}>
                <ModalHeader>Create new App</ModalHeader>
                <ModalBody className={css({ height: 'calc(90vh - 200px)'})} >
                        <ObjectCreator object={object} small={false}></ObjectCreator>
                </ModalBody>
                <ModalFooter>
                    <ModalButton kind="tertiary" onClick={onCancel}>
                        Cancel
                    </ModalButton>
                    <ModalButton onClick={onFinish} disabled={false} >Finish</ModalButton>
                </ModalFooter>
            </Modal>

        </>
    );
}
